
    <template>
      <section class="content element-doc">
        <h2 id="tu-biao-rong-qi"><a class="header-anchor" href="#tu-biao-rong-qi">¶</a> 图表容器</h2>
<div class="tip">
<p>图表容器，封装部分通用方法，提供图表放大、数据,图片下载查看等功能。</p>
<h3 id="ji-ben-gong-neng"><a class="header-anchor" href="#ji-ben-gong-neng">¶</a> 基本功能</h3>
<demo-block>
        
        <template slot="source"><element-demo0 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;charts-box&quot;&gt;
    &lt;ShCharts :title=&quot;'折线图'&quot; @on-amplify=&quot;onAmplify&quot; @on-data-view=&quot;onDataView&quot;&gt;
      &lt;div class=&quot;charts&quot; ref=&quot;chartsRef&quot;&gt;&lt;/div&gt;
    &lt;/ShCharts&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  //   import * as echarts from 'echarts/core'
  //   import { GridComponent } from 'echarts/components'
  //   import { LineChart } from 'echarts/charts'
  //   import { UniversalTransition } from 'echarts/features'
  //   import { CanvasRenderer } from 'echarts/renderers'
  //   echarts.use([GridComponent, LineChart, CanvasRenderer, UniversalTransition])
  const echarts = require('echarts/lib/echarts')
  require('echarts/lib/component/grid')
  require('echarts/lib/chart/line')

  export default {
    data() {
      return {}
    },
    computed: {
      echrtsOptions() {
        return {
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [150, 230, 224, 218, 135, 147, 260],
              type: 'line'
            }
          ]
        }
      }
    },
    mounted() {
      this.initECharts()
    },
    methods: {
      onAmplify() {
        console.log('onAmplify')
      },
      onDataView() {
        console.log('onDataView')
      },
      initECharts() {
        this.$refs.chartsRef &amp;&amp; echarts.init(this.$refs.chartsRef).setOption(this.echrtsOptions)
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block></div>
<h3 id="wan-zheng-gong-neng"><a class="header-anchor" href="#wan-zheng-gong-neng">¶</a> 完整功能</h3>
<demo-block>
        
        <template slot="source"><element-demo1 /></template>
        <template slot="highlight"><pre v-pre><code class="html">&lt;template&gt;
  &lt;div class=&quot;charts-box&quot;&gt;
    &lt;ShCharts @on-amplify=&quot;onAmplify&quot; @on-data-view=&quot;onDataView&quot;&gt;
      &lt;div slot=&quot;title&quot;&gt;自定义标题&lt;/div&gt;
      &lt;div slot=&quot;tools&quot;&gt;自定义工具栏&lt;/div&gt;
      &lt;div class=&quot;charts&quot; ref=&quot;chartsRef&quot;&gt;&lt;/div&gt;
    &lt;/ShCharts&gt;
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
  //   import * as echarts from 'echarts/core'
  //   import { GridComponent } from 'echarts/components'
  //   import { LineChart } from 'echarts/charts'
  //   import { UniversalTransition } from 'echarts/features'
  //   import { CanvasRenderer } from 'echarts/renderers'
  //   echarts.use([GridComponent, LineChart, CanvasRenderer, UniversalTransition])
  const echarts = require('echarts/lib/echarts')
  require('echarts/lib/component/grid')
  require('echarts/lib/chart/line')

  export default {
    data() {
      return {}
    },
    computed: {
      echrtsOptions() {
        return {
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [150, 230, 224, 218, 135, 147, 260],
              type: 'line'
            }
          ]
        }
      }
    },
    mounted() {
      this.initECharts()
    },
    methods: {
      onAmplify() {
        console.log('onAmplify')
      },
      onDataView() {
        console.log('onDataView')
      },
      initECharts() {
        this.$refs.chartsRef &amp;&amp; echarts.init(this.$refs.chartsRef).setOption(this.echrtsOptions)
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h3 id="shu-xing"><a class="header-anchor" href="#shu-xing">¶</a> 属性</h3>
<table>
<thead>
<tr>
<th>参数</th>
<th>说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>title</td>
<td>标题</td>
<td>String</td>
<td>'标题'</td>
</tr>
<tr>
<td>toolsShow</td>
<td>是否显示工具栏</td>
<td>Boolean</td>
<td>true</td>
</tr>
<tr>
<td>headShow</td>
<td>是否显示头部</td>
<td>Boolean</td>
<td>true</td>
</tr>
</tbody>
</table>
<h3 id="shi-jian"><a class="header-anchor" href="#shi-jian">¶</a> 事件</h3>
<table>
<thead>
<tr>
<th>事件名</th>
<th>说明</th>
<th>回调参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>onAmplify</td>
<td>放大事件</td>
<td>-</td>
</tr>
<tr>
<td>onDataView</td>
<td>数据视图事件</td>
<td>-</td>
</tr>
</tbody>
</table>
<h3 id="cha-cao"><a class="header-anchor" href="#cha-cao">¶</a> 插槽</h3>
<table>
<thead>
<tr>
<th>插槽名</th>
<th>说明</th>
<th>参数</th>
</tr>
</thead>
<tbody>
<tr>
<td>-</td>
<td>图表容器</td>
<td>-</td>
</tr>
<tr>
<td>title</td>
<td>自定义标题</td>
<td>-</td>
</tr>
<tr>
<td>tools</td>
<td>自定义工具栏</td>
<td>-</td>
</tr>
</tbody>
</table>

      </section>
    </template>
    <script>
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"charts-box"},[_c('ShCharts',{attrs:{"title":'折线图'},on:{"on-amplify":_vm.onAmplify,"on-data-view":_vm.onDataView}},[_c('div',{ref:"chartsRef",staticClass:"charts"})])],1)]],2)}
var staticRenderFns = []

  
    //   import * as echarts from 'echarts/core'
  //   import { GridComponent } from 'echarts/components'
  //   import { LineChart } from 'echarts/charts'
  //   import { UniversalTransition } from 'echarts/features'
  //   import { CanvasRenderer } from 'echarts/renderers'
  //   echarts.use([GridComponent, LineChart, CanvasRenderer, UniversalTransition])
  const echarts = require('echarts/lib/echarts')
  require('echarts/lib/component/grid')
  require('echarts/lib/chart/line')

  const democomponentExport = {
    data() {
      return {}
    },
    computed: {
      echrtsOptions() {
        return {
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [150, 230, 224, 218, 135, 147, 260],
              type: 'line'
            }
          ]
        }
      }
    },
    mounted() {
      this.initECharts()
    },
    methods: {
      onAmplify() {
        console.log('onAmplify')
      },
      onDataView() {
        console.log('onDataView')
      },
      initECharts() {
        this.$refs.chartsRef && echarts.init(this.$refs.chartsRef).setOption(this.echrtsOptions)
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('div',{staticClass:"charts-box"},[_c('ShCharts',{on:{"on-amplify":_vm.onAmplify,"on-data-view":_vm.onDataView}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_vm._v("自定义标题")]),_vm._v(" "),_c('div',{attrs:{"slot":"tools"},slot:"tools"},[_vm._v("自定义工具栏")]),_vm._v(" "),_c('div',{ref:"chartsRef",staticClass:"charts"})])],1)]],2)}
var staticRenderFns = []

  
    //   import * as echarts from 'echarts/core'
  //   import { GridComponent } from 'echarts/components'
  //   import { LineChart } from 'echarts/charts'
  //   import { UniversalTransition } from 'echarts/features'
  //   import { CanvasRenderer } from 'echarts/renderers'
  //   echarts.use([GridComponent, LineChart, CanvasRenderer, UniversalTransition])
  const echarts = require('echarts/lib/echarts')
  require('echarts/lib/component/grid')
  require('echarts/lib/chart/line')

  const democomponentExport = {
    data() {
      return {}
    },
    computed: {
      echrtsOptions() {
        return {
          xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [150, 230, 224, 218, 135, 147, 260],
              type: 'line'
            }
          ]
        }
      }
    },
    mounted() {
      this.initECharts()
    },
    methods: {
      onAmplify() {
        console.log('onAmplify')
      },
      onDataView() {
        console.log('onDataView')
      },
      initECharts() {
        this.$refs.chartsRef && echarts.init(this.$refs.chartsRef).setOption(this.echrtsOptions)
      }
    }
  }
    return {
      render,
      staticRenderFns,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  